export const WFD_SPELLING_VARIANTS: Readonly<
	Record<string, readonly string[]>
> = {
	aesthetic: ["esthetic"],
	analysing: ["analyzing"],
	analyzing: ["analysing"],
	archaeological: ["archeological"],
	archeological: ["archaeological"],
	artefacts: ["artifacts"],
	artifacts: ["artefacts"],
	behaviors: ["behaviours"],
	behaviours: ["behaviors"],
	canceled: ["cancelled"],
	cancelled: ["canceled"],
	catalog: ["catalogue"],
	catalogue: ["catalog"],
	center: ["centre"],
	centre: ["center"],
	enquiry: ["inquiry"],
	enrol: ["enroll"],
	enroll: ["enrol"],
	esthetic: ["aesthetic"],
	favorite: ["favourite"],
	favourite: ["favorite"],
	flavor: ["flavour"],
	flavour: ["flavor"],
	honor: ["honour"],
	honour: ["honor"],
	inquiry: ["enquiry"],
	maximise: ["maximize"],
	maximize: ["maximise"],
	neighborhood: ["neighbourhood"],
	neighbourhood: ["neighborhood"],
	organise: ["organize"],
	organize: ["organise"],
	penalised: ["penalized"],
	penalized: ["penalised"],
	personalised: ["personalized"],
	personalized: ["personalised"],
	prioritising: ["prioritizing"],
	prioritizing: ["prioritising"],
	scepticism: ["skepticism"],
	skepticism: ["scepticism"],
	watercolors: ["watercolours"],
	watercolours: ["watercolors"],
};
